import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteMediaProvider } from "@/context/SiteMediaContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import CctvSecurity from "@/pages/CctvSecurity";
import About from "@/pages/About";
import OurWork from "@/pages/OurWork";
import Reviews from "@/pages/Reviews";
import ServiceArea from "@/pages/ServiceArea";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/cctv-security" element={<CctvSecurity />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-work" element={<OurWork />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/service-area" element={<ServiceArea />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/request-a-quote" element={<RequestQuote />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SiteMediaProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/*" element={<SiteRoutes />} />
            </Routes>
            <Toaster position="top-center" richColors theme="dark" />
          </SiteMediaProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
